import { MDBDataTable } from "mdbreact"
import Loading from "../Loading"
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Modal, Select, Switch } from "antd";
import axios from "axios";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useEffect } from "react";
import { useRef } from "react";

const mySwal = withReactContent(Swal);

const ExternalVoucherCodeCard = ({ id, role, token, outlets }) => {

    const { t } = useTranslation();
    const fileInputRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [file, setFile] = useState(null);
    const [status, setStatus] = useState("Available");
    const [showModal, setShowModal] = useState(false);
    const [outletOption, setOutletOption] = useState([])
    const [outletApplicable, setOutletApplicable] = useState(false);
    const [outletRules, setOutletRules] = useState([]);

    useEffect(() => {
        if (outlets) {
            let outletList = []
            for (let i = 0; i < outlets.length; i++) {
                let outletObject = {
                    value: outlets[i].id,
                    label: outlets[i].outlet_fullname
                }
                outletList.push(outletObject)
            }
            setOutletOption(outletList)
        }
    }, [outlets])

    useEffect(() => {
        if (id && role) {
            setLoading(true);
            axios
                .get(`/api/admin/setting/externalVoucherCode?id=${id}&role=${role}&status=${status}`, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setData(res.data.data);
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    }, [id, role, status])

    useEffect(() => {
        if (id && role) {
            setLoading(true);
            axios
                .get(`/api/admin/setting/generalStamp?id=${id}&role=${role}`, { headers: { "Content-Type": "application/json", "auth-token": token } })
                .then(res => {
                    setOutletRules(res.data.data.map(rule => rule.outletId));
                    if (res.data.data && res.data.data.length > 0) {
                        setOutletApplicable(res.data.data[0].applicable);
                    }
                    setLoading(false);
                })
                .catch(err => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        }
    }, [id, role])

    const handleFile = (e) => {
        let selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type !== "text/csv") {
            mySwal.fire(t("Error"), t("Please select a valid CSV file"), "error");
            e.target.value = null;
        } else if (selectedFile) {
            setFile(e.target.files[0]);
        } else {
            e.target.value = null;
            setFile(null);
        }
    }

    const handleImport = (e) => {
        e.preventDefault();

        if (file) {
            setLoading(true);
            const formData = new FormData();
            formData.append("file", file);
            formData.append("id", id);
            formData.append("role", role);

            axios
                .post(`/api/admin/setting/externalVoucherCode`, formData, { headers: { "auth-token": token } })
                .then(res => {
                    mySwal.fire(t("Success"), t("External Voucher Code imported successfully"), "success");
                    fileInputRef.current.value = null;
                    setFile(null);
                    setShowModal(false);

                    axios
                        .get(`/api/admin/setting/externalVoucherCode?id=${id}&role=${role}&status=${status}`, { headers: { "Content-Type": "application/json", "auth-token": token } })
                        .then(res => {
                            setData(res.data.data);
                            setLoading(false);
                        })
                        .catch(err => {
                            setLoading(false);
                            mySwal.fire(t("Error"), t(err.response.data.error), "error");
                        });
                })
                .catch(err => {
                    setLoading(false);
                    mySwal.fire(t("Error"), t(err.response.data.error), "error");
                });
        } else {
            mySwal.fire(t("Error"), t("Please select a CSV file to import"), "error");
        }
    }

    const handleGeneralStampSetting = () => {
        setLoading(true);
        axios
            .post(`/api/admin/setting/generalStamp`, { id, role, outletApplicable, outletRules }, { headers: { "Content-Type": "application/json", "auth-token": token } })
            .then(res => {
                mySwal.fire(t("Success"), t("Voucher Code Stamp setting updated successfully"), "success");
                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                mySwal.fire(t("Error"), t(err.response.data.error), "error");
            })
    }

    let tableData = {
        columns: [
            {
                label: t("Code"),
                field: "code",
                sort: "asc"
            },
            {
                label: t("Status"),
                field: "status",
                sort: "asc"
            },
            {
                label: t("Member ID"),
                field: "member_id",
                sort: "asc"
            },
            {
                label: t("Name"),
                field: "name",
                sort: "asc"
            },
            {
                label: t("Phone Number"),
                field: "number",
                sort: "asc"
            },
            {
                label: t("Email"),
                field: "email",
                sort: "asc"
            },
            {
                label: t("Upload Date"),
                field: "createdAt",
                sort: "asc"
            },
        ],
        rows: data
    }

    return (
        <div>
            <div className="card">
                <div className="card-header d-flex justify-content-between">
                    <h5 className="card-title">{t("External Voucher Code")}</h5>

                    <button className="btn btn-primary" type="button" onClick={() => setShowModal(true)}>
                        {t("Import Voucher Code")}
                    </button>
                </div>

                <div className="card-body">

                    <div className="mb-5">
                        <h6>{t("Voucher Code Stamp Settings")}</h6>
                        <div className="form-group mt-1">
                            <div className="d-flex">
                                <Switch value={outletApplicable} onChange={e => setOutletApplicable(!outletApplicable)} />
                                <p className="ps-2">{outletApplicable ? t("Only applicable to selected outlet") : t("Applicable to all the outlets except selected outlet")}</p>
                            </div>

                            <label htmlFor="outletId">{t("Outlet")}</label>
                            <Select
                                id="outletId"
                                name="outletId"
                                mode="multiple"
                                allowClear
                                style={{ width: '100%' }}
                                placeholder={t("Select Outlet")}
                                showSearch
                                optionFilterProp="label"
                                onChange={(value) => setOutletRules(value)}
                                options={outletOption}
                                value={outletRules}
                            />
                        </div>

                        {
                            loading ? (
                                <Loading />
                            ) : (
                                <div className="text-center">
                                    <button type="button" className="btn btn-block big-button" onClick={e => handleGeneralStampSetting()}>
                                        {t("Submit")}
                                    </button>
                                </div>
                            )
                        }
                    </div>

                    <div className="mb-3">
                        <h6>{t("Filter")}</h6>
                        <div>
                            <label htmlFor="status">{t("Status")}: </label>
                            <Select
                                id="status"
                                name="status"
                                style={{ width: '100%' }}
                                placeholder={t("Status")}
                                showSearch
                                optionFilterProp="label"
                                onChange={(value) => setStatus(value)}
                                options={[
                                    { value: "Available", label: t("Available") },
                                    { value: "Redeemed", label: t("Redeemed") },
                                ]}
                                value={status}
                            />
                        </div>
                    </div>
                    <div>
                        {
                            loading
                                ? <Loading />
                                : <MDBDataTable data={tableData} noBottomColumns striped hover responsive bordered />
                        }
                    </div>
                </div>
            </div>

            <Modal
                title={t("Import External Voucher Code")}
                open={showModal}
                footer={null}
                onCancel={e => setShowModal(false)}
                centered
            >
                <form onSubmit={e => handleImport(e)}>
                    <input type="file" accept=".csv" ref={fileInputRef} onChange={e => handleFile(e)} required />
                    <div className="d-flex justify-content-center mt-3">
                        <button className="btn btn-primary" type="submit">{t("Import")}</button>
                        <button className="btn btn-secondary ms-2" type="button" onClick={e => setShowModal(false)}>{t("Cancel")}</button>
                    </div>
                </form>
            </Modal>
        </div>
    )
}

export default ExternalVoucherCodeCard